import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {
		background: THEME.colors.background.light,
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		padding: THEME.spacing.md,
	},
	counts: {
		color: THEME.colors.text.light,
		display: 'flex',
		flexWrap: 'wrap',
		fontSize: THEME.typography.fontSizes.xs,
		gap: THEME.spacing.md,
		margin: 0,
	},
	currentContact: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
		margin: 0,
		...THEME.common.truncate,
	},
	error: {
		color: THEME.colors.danger.main,
		fontSize: THEME.typography.fontSizes.xs,
		margin: 0,
	},
	header: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
	},
	percent: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
	},
	progressTrack: {
		background: THEME.colors.background.main,
		borderRadius: THEME.common.borderRadius,
		height: 8,
		overflow: 'hidden',
	},
	progressFill: {
		background: THEME.colors.primary.main,
		height: '100%',
		transition: 'width 0.3s ease',
	},
	status: {
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.bold,
		margin: 0,
	},
});
